import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { PackageStatusCategory } from 'src/app/features/packages/models';
import { PackagesService } from 'src/app/features/packages/services';
import { SignalRActions } from 'src/app/features/signal-r/store';
import {
  DEFAULT_APPLICATION_PHONE_NUMBER,
  ROCKET_MORTGAGE_CLOSING_TEAM_NUMBER,
} from 'src/app/features/shared/constants';

import { RootStoreState } from 'src/app/store';

@Component({
    selector: 'app-cancelled-signing',
    templateUrl: './cancelled-signing.component.html',
    styleUrls: ['./cancelled-signing.component.scss'],
    standalone: false
})
export class CancelledSigningComponent implements OnInit {
  supportPhoneNumber = DEFAULT_APPLICATION_PHONE_NUMBER;

  constructor(
    private readonly store: Store<RootStoreState.State>,
    private readonly route: ActivatedRoute,
    private readonly packagesService: PackagesService
  ) {}

  ngOnInit(): void {
    this.store.dispatch(SignalRActions.StopSignalRConnection());

    const packageGuid = this.route.snapshot.queryParams['package'];
    if (!packageGuid) {
      return;
    }

    this.packagesService.getPackageStatus(packageGuid).subscribe({
      next: (status) => {
        if (status?.categoryTypeCode === PackageStatusCategory.KbaFail) {
          this.supportPhoneNumber = ROCKET_MORTGAGE_CLOSING_TEAM_NUMBER;
        }
      },
      error: () => {},
    });
  }
}
